// extracted by mini-css-extract-plugin
var _1 = "HW0mF";
var _2 = "V39dB";
export { _1 as "tag", _2 as "warn" }
